

















import Global from '@/js/global.js'
import ApiClient from '@/js/api.js'

export default
  name: 'CartPriceArea'

  props:
    prefID:
      type: String
      default: '0'
    use_point:
      type: String
      default: '0'

  watch: {
    prefID: (val) ->
      if val == '0'
        return
      param =
        pref_id: val
      api = new ApiClient()
      data = await api.post('/member/cart/total_price', true, param)
      @priceData = data
      @$emit('set_point', data.point)
  }

  data: () ->
    priceData: null

  computed: {
    point: () ->
      if @use_point == '0'
        return 0
      return @priceData.point
  }

  methods: {
    comma: (price) ->
      Global.comma price
  }
